import script from "./singleCommentDisplayer.vue?vue&type=script&setup=true&lang=js"
export * from "./singleCommentDisplayer.vue?vue&type=script&setup=true&lang=js"

import "./singleCommentDisplayer.vue?vue&type=style&index=0&id=3a2e1256&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a2e1256"]])

export default __exports__